import { defineMessages } from 'react-intl.macro';

export default defineMessages({
  headingProjects: {
    id: 'views.OurProducts.headingProjects',
    defaultMessage: 'Nasze projekty:'
  },
  headingProducts: {
    id: 'views.OurProducts.headingProducts',
    defaultMessage: 'Nasze produkty:'
  }
});



// WEBPACK FOOTER //
// ./src/common/components/Products/OurProducts.intl.js